import {
  FaBolt,
  FaLayerGroup,
  FaUserCircle,
  FaQuestionCircle,
  FaBrain,
  FaDownload,
  FaGlobeAsia,
  FaSignInAlt,
  FaSignOutAlt,
} from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles_1/Sidebar.css";
import { User } from "../types";

// Sidebar now accepts onExport to trigger the unified backup
export const Sidebar: React.FC<{
  onLogin: () => void;
  onLogout?: () => void;
  onExport?: () => void;
  onImport?: (file: File) => void;
  user?: User | null;
}> = ({ onLogin, onLogout, onExport, onImport, user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Helper to check if a tab is active based on the current URL path
  const isActive = (path: string) =>
    location.pathname === path ? "active" : "";

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <img src="/logo.png" alt="ScoreSmart Logo" className="logo-img" />
        </div>
        <p className="tagline">Crafted for Smart Prep</p>
      </div>

      <nav className="sidebar-nav">
        <button
          className={`nav-item ${isActive("/")}`}
          onClick={() => navigate("/")}
        >
          <FaLayerGroup /> Dashboard
        </button>

        <button
          className={`nav-item ${isActive("/generator")}`}
          onClick={() => navigate("/generator")}
        >
          <FaBolt /> Flashcards
        </button>

        <button
          className={`nav-item ${isActive("/recall")}`}
          onClick={() => navigate("/recall")}
        >
          <FaBrain /> Recall Sheets
        </button>

        <button
          className={`nav-item ${isActive("/atlas")}`}
          onClick={() => navigate("/atlas")}
        >
          <FaGlobeAsia /> Atlas Tool
        </button>

        <button
          className={`nav-item ${isActive("/how-to")}`}
          onClick={() => navigate("/how-to")}
        >
          <FaQuestionCircle /> How to Use
        </button>

        <button
          className={`nav-item ${isActive("/about")}`}
          onClick={() => navigate("/about")}
        >
          <FaBrain /> About Us
        </button>

        <button
          className={`nav-item ${isActive("/profile")}`}
          onClick={() => {
            if (!user) {
              onLogin();
            } else {
              navigate("/profile");
            }
          }}
        >
          <FaUserCircle /> My Profile
        </button>
      </nav>

      <div className="sidebar-export-section" style={{ paddingTop: '8px' }}>
        <div className="export-row">
          <button className="export-all-btn" onClick={onExport} title="Save all progress to local file">
            <FaDownload /> Export
          </button>
          <button className="export-all-btn" onClick={() => document.getElementById('global-import-input')?.click()} title="Load progress from a backup file" style={{ background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0' }}>
            <span style={{ marginRight: '4px' }}>📂</span> Load
          </button>
        </div>
        <input
          id="global-import-input"
          type="file"
          hidden
          accept=".fgdata,.json"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onImport?.(file);
          }}
        />
      </div>

      <div className="sidebar-footer">
        {user ? (
          <div className="sidebar-auth-section">
            <div className="user-info">
              <FaUserCircle size={20} />
              <div className="user-details">
                <span className="user-email">{user.email || "User"}</span>
                <button className="auth-link-btn" onClick={onLogout}>
                  <FaSignOutAlt size={12} /> Sign Out
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="sidebar-auth-section">
            <button className="auth-btn primary" onClick={onLogin}>
              <FaSignInAlt /> Sign In
            </button>
            <button className="auth-btn secondary" onClick={onLogin}>
              Sign Up
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};
